/**
 * A collection of Local Web Storage API related functions. Use this utility instead of
 * directly calling Local Storage.
 */

// --- Constants ---

const ITEM = Object.freeze({
  SOFLOW_USER_TOKEN: "soflow-user-token",
  FLOW_GUEST_LOCALE: "soflow-guest-locale",
});

// --- Functions ---

/**
 * Removes other items from the Local Storage except "flow-history-*" keys.
 */


function getUserToken() {
  return localStorage.getItem(ITEM.SOFLOW_USER_TOKEN);
}

function removeUserToken() {
  return localStorage.removeItem(ITEM.SOFLOW_USER_TOKEN);
}

function setUserToken(userToken) {
  localStorage.setItem(ITEM.SOFLOW_USER_TOKEN,userToken);
}

function clear() {
  this.removeUserToken();
  localStorage.removeItem(ITEM.FLOW_GUEST_LOCALE);
}

function getGuestLocale() {
  return localStorage.getItem(ITEM.FLOW_GUEST_LOCALE);
}

function setGuestLocale(locale) {
  localStorage.setItem(ITEM.FLOW_GUEST_LOCALE,locale);
}

export default {

  // --- Functions ---

  getUserToken,
  removeUserToken,
  setUserToken,
  clear,
  getGuestLocale,
  setGuestLocale
}
